(function () {
  function initialiseTabs(root) {
    if (!root || root.dataset.hbTabsInitialised === 'true') {
      return;
    }

    root.dataset.hbTabsInitialised = 'true';

    const tabs = Array.from(
      root.querySelectorAll('[data-hb-tab]')
    );

    const panels = Array.from(
      root.querySelectorAll('[data-hb-panel]')
    );

    if (!tabs.length || !panels.length) {
      return;
    }

    function activateTab(selectedTab, moveFocus) {
      const selectedName = selectedTab.dataset.hbTab;

      tabs.forEach(function (tab) {
        const isActive = tab === selectedTab;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        const isActive =
          panel.dataset.hbPanel === selectedName;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (moveFocus) {
        selectedTab.focus();
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        let nextIndex = null;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        }

        if (event.key === 'ArrowLeft') {
          nextIndex =
            (index - 1 + tabs.length) % tabs.length;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex === null) {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    const defaultTab =
      tabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      }) || tabs[0];

    activateTab(defaultTab, false);
  }

  function initialiseAllTabs(scope) {
    if (
      scope.matches &&
      scope.matches('[data-hb-tabs]')
    ) {
      initialiseTabs(scope);
    }

    scope
      .querySelectorAll('[data-hb-tabs]')
      .forEach(initialiseTabs);
  }

  function initialisePage() {
    initialiseAllTabs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialisePage
    );
  } else {
    initialisePage();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseAllTabs(event.target);
    }
  );
})();